import BranchDetails from "./BranchDetails";

export default BranchDetails;
